/**
 * engine/i18n — i18n minimal AR/FR/EN + RTL (headless), seam vers @mostajs/i18n.
 * @author Dr Hamid MADANI <drmdh@msn.com>
 *
 * MOTEUR — futur `@mostajs/app-admin` (N1). Fonctions pures (aucun React).
 * À l'adoption, remplacer par `@mostajs/i18n` (FR/EN/AR + RTL natif).
 */
export const LOCALES = ['ar', 'fr', 'en'];
export const RTL_LOCALES = ['ar'];

const DICT = {
  ar: {
    'app.title': 'إدارة TicketFlow',
    'login.title': 'تسجيل الدخول',
    'login.username': 'اسم المستخدم',
    'login.password': 'كلمة المرور',
    'login.submit': 'دخول',
    'pwd.title': 'يجب تغيير كلمة المرور الافتراضية',
    'pwd.current': 'كلمة المرور الحالية',
    'pwd.new': 'كلمة المرور الجديدة',
    'pwd.submit': 'تغيير',
    'config.save': 'حفظ',
    'config.saved': 'تم الحفظ',
    'config.discard': 'لديك تعديلات غير محفوظة. هل تريد تجاهلها وإعادة التحميل؟',
  },
  fr: {
    'app.title': 'Administration TicketFlow',
    'login.title': 'Connexion',
    'login.username': "Nom d'utilisateur",
    'login.password': 'Mot de passe',
    'login.submit': 'Se connecter',
    'pwd.title': 'Le mot de passe par défaut doit être changé',
    'pwd.current': 'Mot de passe actuel',
    'pwd.new': 'Nouveau mot de passe',
    'pwd.submit': 'Changer',
    'config.save': 'Enregistrer',
    'config.saved': 'Enregistré',
    'config.discard': 'Des modifications ne sont pas enregistrées. Les abandonner et recharger ?',
  },
  en: {
    'app.title': 'TicketFlow Administration',
    'login.title': 'Sign in',
    'login.username': 'Username',
    'login.password': 'Password',
    'login.submit': 'Sign in',
    'pwd.title': 'The default password must be changed',
    'pwd.current': 'Current password',
    'pwd.new': 'New password',
    'pwd.submit': 'Change',
    'config.save': 'Save',
    'config.saved': 'Saved',
    'config.discard': 'You have unsaved changes. Discard them and reload?',
  },
};

export function isRtl(locale) {
  return RTL_LOCALES.includes(locale);
}

/** Fabrique un traducteur `t(key)` pour la locale + un résolveur `{ar,fr,en}`. */
export function makeT(locale) {
  const table = DICT[locale] || DICT.fr;
  const t = (key) => table[key] ?? key;
  t.localized = (obj, fallback = '') => {
    if (obj == null) return fallback;
    if (typeof obj === 'string') return obj;
    return obj[locale] ?? obj.fr ?? obj.en ?? obj.ar ?? fallback;
  };
  return t;
}
